import styled from "styled-components";
import theme from "./theme";

const pointYellow = theme.colors.pointYellow;
const md = theme.screens.md;

export const LoginContainer = styled.section<{$background:string}>`
    position: relative;
    width: 100%;
    height: 100vh;

    &::before {
        content: '';
        display: block;
        padding-top: 50px;
        width: 100%;
        height: 100vh;
        background-color: #111;
        /* background: no-repeat right/cover url(${require('../assets/images/bg_b2b_1.png')}); */
        background: no-repeat right/cover url(${props => props.$background});
    }
`;

export const LoginHeader = styled.div`
    position: absolute;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 47px;
    background-color: #000;
    border-bottom: 3px solid ${pointYellow};
    color: #fff;
    z-index: 1;

    & ul {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        padding: 10px 0;
        margin: 0 auto;
        width: 90%;
    }

    & .login-top-bar-logo {
        max-width: 60px;
        width: 65%;
        overflow: hidden;
    }

    & .login-top-bar-text {
        color: #fff;
        line-height: 16px;
        font-size: 16px;
    }
`;

export const LoginWrap = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 81%;
    max-width: 840px;
    color: #000;
    z-index: 1;
    overflow: hidden;

    @media ${md} {
        display: block;
        margin-top: -20px;
        width: 100%;
    }

    & .login-title-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        margin: auto;
        width: 50%;
        height: 380px;
        background-color: rgba(19, 19, 19, 0.8);
        border-radius: 10px 0 0 10px;
        color: #fff;

        & .login-title p {
            font-size: 40px;
            font-weight: 600;
            letter-spacing: 2px;
            padding: 10px 20px;

            @media ${md} {
                font-size: 24px;
            }
        }

        & .login-sub-title {
            font-size: 21px;
            line-height: 1.5;
            letter-spacing: -0.1px;
        }

        & .login-sub-title p {
            padding: 10px 20px;
        }

        & .login-sub-title p:last-child{
            font-size: 14px;
            font-weight: 400;
            color: #ccc;
        }

        @media ${md} {
            width: 90%;
            height: 137px;
            border-radius: 10px 10px 0 0;
        }
    }
    & .login-con-wrap {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        margin: auto;
        width: 50%;
        height: 380px;
        background-color: rgba(255, 255, 255, 0.9);
        padding: 77px 0;
        border-radius: 0 10px 10px 0;

        @media ${md} {
            width: 90%;
            height: 320px;
            border-radius: 0 0 10px 10px;
            padding: 50px 0 60px;
        }

        & .login-content {
            width: 100%;
        }

        & .logo-box {
            max-width: 150px;
            margin: 0 auto 35px;

            @media ${md} {
                max-width: 125px;
            }
        }

        & .login-user-info {
            width: 80%; margin: 0 auto 10px;
        }

        & .login-user-info input {
            display: block;
            margin: 0 auto;
            width: 100%;
            height: 36px;
            margin-bottom: 10px;
            border-radius: 0;
            border: 1px solid #e4e4e4;
            padding: 5px 8px;
            outline: none;
        }

        & .login-user-info input::placeholder {
            color: #808080;
        }
        & .login-user-info button {
            display: block;
            margin: 0 auto;
            width: 100%;
            padding: 8px 0;
        }
        & .login-btn {
            height: 40px;
            background-color: #000;
            color: #fff;
            border: none;
        }

        & .login-a1 {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 80%;
            margin: 0 auto;

            & .login-check-box {
                display: flex;
                align-items: center;

                & .login-check {
                    margin-right: 8px;
                }
            }

            & .find-user-info {
                display: flex;
                font-size: 14px;
                letter-spacing: -0.1px;

                & span {
                    border-bottom: 1px solid #000;
                }
                & span:hover {
                    cursor: pointer;
                }
            }
        }

        & .policy-box {
            position: absolute;
            display: flex;
            bottom: 15px;
            left: 50%;
            transform: translateX(-50%);

            & button {
                font-size: 14px;
                width: 100px;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
`;

export const ModalBack = styled.div`
    position: absolute;
    width: 100%;
    height: 100vh;
    top: 0;
    z-index: 99;

    &::before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0,0,0,0.5);
        width: 100%;
        height: 100vh;
        z-index: 100;
    }

    & .modal-container {
        width: 100%;
        max-width: 640px;
        background-color: #fff;
        position: absolute;
        top: 50%; left: 50%;
        transform: translate(-50%,-50%);
        z-index: 101;
        padding: 40px 0;
        overflow: auto;

        & .popup-close {
            margin: 0 auto 30px;
            text-align: center;
        }
        & .popup-close::after {
            content: '';
            display: block;
            clear: both;
        }

        & .popup-title {
            display: inline-block;
            font-size: 14px;
            padding: 5px 15px;
            border: 1px solid #000;
            border-radius: 25px;
        }

        & .login-find-myinfo-input-box {

            & .login-find-myinfo-input-box-con {
                display:flex;
                align-items: center;
                justify-content: space-between;
                height: 40px;
                width: 60%;
                margin: 0 auto 16px;
                border: 1px solid #000;

                & input {
                    border: none;
                    width: 100%;
                    height: 100%;
                    outline: none;
                    padding-left: 8px;
                }

                & button {
                    width: 30%;
                    height: 40px;
                    background-color: #000;
                    border-radius: none;
                    border: none;
                    color: #fff;
                }
            }
        }

    }
`;

export const mobileNotice = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    bottom: 14%;
    width: 100%;

    & div {
        width: 250px;
        background-color: #f8b700;
        margin: 0 auto;
        padding: 8px 4px;
        text-align: center;
    }
`;